module.exports = __webpack_public_path__ + "static/vv-78a49973a3a9dee1e14bf95453d880fa.png";